import { useContext, useMemo } from "react";

import { AuthContext } from "../../../contexts/auth";
import type { ProjectStoragePermissions } from "../types/project-storage.types";

export function useProjectStoragePermissions(): ProjectStoragePermissions {
  const { actionOptions } = useContext(AuthContext);

  return useMemo(
    () => ({
      canView: !!actionOptions.viewProjetos,
      canEdit: !!actionOptions.updateProjetos,
    }),
    [actionOptions.updateProjetos, actionOptions.viewProjetos]
  );
}
